<template>
	<v-card>
		<v-card-title>
			<h2>Kody DAC</h2>
			<v-spacer></v-spacer>
		</v-card-title>
		<v-dialog v-model="dialog" max-width="500px">
			<v-btn slot="activator" color="primary" dark class="ml-3 mt-3 mb-3">Dodaj kod DAC</v-btn>
			<v-card>
				<v-card-title>
					<span class="headline" v-if="isEdited()">Edycja kodu</span>
					<span class="headline" v-else>Dodaj nowy kod</span>
				</v-card-title>

				<v-card-text>
					<v-container grid-list-md>
						<v-layout wrap>
							<v-flex xs12 sm6 md12>
								<v-text-field v-model="editedItem.code"
									browser-autocomplete="off"
									aria-label="code"
									label="Kod"
									for="dacc-codes-view-code"
									id="dacc-codes-view-code"
								></v-text-field>
							</v-flex>
							<v-flex xs12 sm6 md12>
								<v-textarea auto-grow outline v-model="editedItem.description"
									browser-autocomplete="off"
									aria-label="description"
									label="Opis"
									for="dacc-codes-view-description"
									id="dacc-codes-view-description"
								></v-textarea>
							</v-flex>
						</v-layout>
					</v-container>
				</v-card-text>

				<v-card-actions>
					<v-spacer></v-spacer>
					<v-btn color="blue" @click="close">Anuluj</v-btn>
					<v-btn color="primary" @click="save">{{ isEdited ? "Zapisz" : "Utwórz"}}</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>

		<egranty-table :items="codes"
			:headers="headers"
			:table-name="''"
			:row-actions="actions"
			export-sorted-by-field-name="code"
			@edit="editItem"
			@delete="deleteItem"
		></egranty-table>
	</v-card>
</template>

<script>
	import EgrantyTable from "../../../genericComponents/EgrantyTable";
	import {DacCodes} from "../../../api/generated/DacCodes";

	export default {
		name: "DACCodesView",
		components: {EgrantyTable},

		data() {
			return {
				dialog: false,
				edit: false,
				codes: [],
				headers: [
					{text: "Kod", value: "code"},
					{text: "Opis", value: "description"},
				],
				actions: [
					{name: "edit", icon: "edit"},
					{name: "delete", icon: "delete"},
				],
				editedItem: {},
			};
		},

		mounted() {
			this.update();
		},

		methods: {

			isEdited() {
				return this.edit;
			},

			update() {
				DacCodes.get(this, successResponse => {
						this.codes = successResponse;
					},
					errorResponse => {
						this.$messagesBus.$emit("error", "Nie udało się pobrać listy kodów DAC", errorResponse);
					});
			},

			editItem(item) {
				this.editedItem = Object.assign({}, item);
				this.edit = true;
				this.dialog = true;
			},

			deleteItem(item) {
				this.$confirm("Czy na pewno chcesz usunąć kod DAC?", {
					icon: 'delete',
					title: 'Usuwanie kodu DAC',
					color: 'lightred',
					width: 500
				})
					.then(response => {
						if (response) {
							DacCodes.deleteDacCode(this, item.id, successResponse => {
									this.$messagesBus.$emit("success", "Kod DAC został pomyślnie usunięty", successResponse);
									this.update();
								},
								errorResponse => {
									this.$messagesBus.$emit("error", errorResponse.errors[0], errorResponse);
								});
						}
					});
			},

			close() {
				this.dialog = false;
				this.edit = false;
				this.editedItem = {};
			},

			save() {
				if (this.isEdited()) {
					DacCodes.putDacCode(this, this.editedItem.id, this.editedItem.code, this.editedItem.description, () => {
						this.close();
						this.$messagesBus.$emit("success", "Kod DAC został pomyślnie zapisany", "");
						this.update();
					}, errorResponse => {
						this.$messagesBus.$emit("error", errorResponse.errors[0], errorResponse);
					});
				} else {
					DacCodes.post(this, this.editedItem.code, this.editedItem.description, () => {
						this.close();
						this.$messagesBus.$emit("success", "Kod DAC został pomyślnie dodany", "");
						this.update();
					}, errorResponse => {
						this.$messagesBus.$emit("error", errorResponse.errors[0], errorResponse);
					});
				}
			},
		},
	};
</script>
